import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Bitcoin } from 'lucide-react';

export default function CryptoWidget() {
  const [prices, setPrices] = useState(null);

  useEffect(() => {
    const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
    const fetchPrices = () =>
      fetch(`${API}/public/crypto-prices`)
        .then(r => r.json()).then(setPrices).catch(() => {});
    fetchPrices();
    const t = setInterval(fetchPrices, 60000);
    return () => clearInterval(t);
  }, []);

  const items = [
    { id: 'bitcoin', sym: 'BTC', name: 'Bitcoin' },
    { id: 'ethereum', sym: 'ETH', name: 'Ethereum' },
    { id: 'tether', sym: 'USDT', name: 'Tether' },
    { id: 'binancecoin', sym: 'BNB', name: 'BNB' },
  ];

  return (
    <div className="bg-white dark:bg-[#0f172a] rounded-xl p-5 border border-gray-100 dark:border-gray-800" data-testid="crypto-widget">
      <h3 className="text-sm font-bold uppercase tracking-wider text-gray-900 dark:text-gray-100 border-l-4 border-amber-500 pl-3 mb-4 flex items-center gap-2">
        <Bitcoin size={14} className="text-amber-500" /> Kripto tečaj
      </h3>
      <div className="space-y-2">
        {items.map(it => {
          const p = prices?.[it.id];
          const chg = p?.eur_24h_change;
          return (
            <div key={it.id} className="flex items-center justify-between py-1.5 border-b border-gray-100 dark:border-gray-800 last:border-0">
              <div>
                <div className="text-sm font-bold text-gray-900 dark:text-gray-100">{it.sym}</div>
                <div className="text-[10px] text-gray-400">{it.name}</div>
              </div>
              <div className="text-right">
                <div className="text-sm font-mono text-gray-700 dark:text-gray-200">{p ? `€${Number(p.eur).toLocaleString('hr-HR', { maximumFractionDigits: 2 })}` : '—'}</div>
                {chg !== undefined && (
                  <div className={`text-[10px] font-bold ${chg >= 0 ? 'text-emerald-500' : 'text-red-500'}`}>
                    {chg >= 0 ? '▲' : '▼'} {Math.abs(chg).toFixed(2)}%
                  </div>
                )}
              </div>
            </div>
          );
        })}
      </div>
      <Link to="/kripto" className="mt-3 block text-center text-xs font-semibold text-red-600 hover:underline">
        Kripto napojnice →
      </Link>
    </div>
  );
}
